const MAX_SIDE = 1200;

/**
 * A large photo made small in the browser, so a phone's full-size picture still
 * fits what the server can open. If the browser cannot read it, the original
 * goes up and the server gives the reason.
 */
export async function shrinkImage(file) {
  try {
    const bitmap = await createImageBitmap(file);
    const scale = Math.min(1, MAX_SIDE / Math.max(bitmap.width, bitmap.height));
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(bitmap.width * scale);
    canvas.height = Math.round(bitmap.height * scale);
    const context = canvas.getContext('2d');
    context.fillStyle = '#ffffff';
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
    bitmap.close();
    const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', 0.92));
    return blob ? new File([blob], 'profile.jpg', { type: 'image/jpeg' }) : file;
  } catch {
    return file;
  }
}
